import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconNewFolder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 71,
	height: 83,
	viewBox: "0 0 71 83",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M71 4.94464C71 2.22123 68.7748 -9.72665e-08 66.0465 -2.16524e-07L22.9615 -2.09983e-06C35.8354 2.41438 50.2766 5.11848 50.9797 5.25368C55.2559 6.09067 57.7907 9.30983 57.7907 13.9068L57.7907 77.4661L59.4419 77.4661C62.1701 77.4661 64.3953 75.2448 64.3953 72.5214L64.3953 29.7194C64.563 29.2622 66.0594 28.3222 66.8721 27.8136C68.8973 26.5453 71 25.2447 71 23.075L71 4.94464ZM54.4884 13.9068C54.4884 11.795 53.7466 9.16819 50.3089 8.4986C49.2382 8.28614 15.0088 1.86712 5.05669 -2.88247e-06L4.95349 -2.88698e-06C2.2252 -3.00624e-06 7.5323e-06 2.22122 7.41326e-06 4.94464L4.60347e-06 69.225C4.48668e-06 71.8969 2.14135 74.0795 4.7987 74.1696L49.2253 82.3592L49.5349 82.4107C52.2632 82.4107 54.4884 80.1895 54.4884 77.4661L54.4884 13.9068Z",
			fill: "#FFB900"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 27,
			cy: 43,
			rx: 20,
			ry: 19,
			fill: "#B98600"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.3807 31L17.6088 40.7719C16.7971 41.5837 16.7971 42.8957 17.6088 43.7075C18.4205 44.5192 19.7326 44.5192 20.5443 43.7075L25.3047 38.9471V54.696C25.3047 55.8419 26.2327 56.772 27.3807 56.772C28.5288 56.772 29.4568 55.8419 29.4568 54.696V38.9471L34.2171 43.7075C34.622 44.1123 35.1534 44.3157 35.6849 44.3157C36.2164 44.3157 36.7478 44.1123 37.1527 43.7075C37.9644 42.8957 37.9644 41.5837 37.1527 40.7719L27.3807 31Z",
			fill: "white"
		})
	]
});
export default SvgIconNewFolder;
